import { useTranslate } from "@similarweb/i18n-provider";
import type {
    ActivationContractGoogleAnalyticsGaMappingRequest,
    ActivationContractGoogleAnalyticsGaMappingResponse,
} from "@similarweb/pro-api-client";
import type { IButtonProps } from "@similarweb/ui-components";

import { useApiMutation } from "app/modules/api-client";

import { GaConnectButton } from "./GaConnectButton";
import { useInvalidateRelatedGaMappingQueries } from "./hooks";
import { GaConnectTexts } from "./texts";

interface IGaReconnectButtonProps
    extends Omit<ActivationContractGoogleAnalyticsGaMappingRequest, "isActive">,
        Pick<IButtonProps, "dataAutomation"> {
    activationId: string;
    onSuccess?: (data: ActivationContractGoogleAnalyticsGaMappingResponse) => void;
}

export const GaReconnectButton = ({ activationId, dataAutomation, onSuccess, ...other }: IGaReconnectButtonProps) => {
    const { translate } = useTranslate();
    const invalidateRelatedGaMappingQueries = useInvalidateRelatedGaMappingQueries(activationId);
    const { mutate, isPending } = useApiMutation("Activation", "activationGaMappingUpdate", {
        onSuccess: async (data) => {
            await invalidateRelatedGaMappingQueries();

            onSuccess?.(data);
        },
    });

    const handleClick = () => {
        mutate([activationId, { ...other, isActive: true }]);
    };

    return (
        <GaConnectButton
            data-automation={dataAutomation}
            isLoading={isPending}
            label={translate(GaConnectTexts.gaReconnectButtonLabel)}
            onClick={handleClick}
        />
    );
};
